import { mapState } from "vuex";
import { DATE_FORMAT_SHORT, Role, statusColor, TIME_PM, MATERNITY_LEAVE_TYPE, WORKING_TIME_ONSIDE_REQUEST } from "../../../components/commons/commonConstant";
import {
  checkShowWithLastTimesheet,
  downloadFile,
  formatDate,
  getData,
  getInfoStaff,
  toFixedNumber,
} from "../../../components/commons/commons";
import ConfirmModal from "../../../components/RequestManagement/ConfirmModal.vue";
import HistoryList from "../../../components/leave-management/HistoryModal/HistoryList.vue";
import http from "../../../store/modules/helpers/httpInterceptor";
import { computed } from "vue";

export default {
  name: "request-detail",
  components: { ConfirmModal, HistoryList },
  props: {
    data: Object,
    lastTimesheet: Object,
    getRequestList: {
      type: Function,
    },
    hideDrawer: {
      type: Function,
    },
    checkDateWithinApprovedTimesheet: {
      type: Function,
    },
    checkShowWithdraw: {
      type: Function,
    },
    checkShowReject: {
      type: Function,
    },
    checkShowApprove: {
      type: Function,
    },
    handleClickApprove: {
      type: Function,
    },
    handleClickReject: {
      type: Function,
    },
    handleClickWithdraw: {
      type: Function,
    },
    fileList: { type: Array },
    isVariableToDownLoad: Boolean,
  },
  data() {
    return {
      statusColor,
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },
      visibleDelegate: false,
      visibleModalReject: false,
      isSingleRecord: false,
      fetching: false,
      request_type: "request",
      reasonReject: this.data?.reasons_for_rejection || null,
      timeout: null,
      statusPayload: {},
      isLoading: false,
      visibleModalConfirm: false,
      isApprove: false,
      isMaternityLeave: false,
      isOnsiteRequest: false,
      historyActive: null,
      activeId: null,
      requestDetailSpan: 24,
    };
  },
  provide() {
    return {
      activeId: computed(() => this.activeId),
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "request_detail" });
    this.rejectForm = this.$form.createForm(this, { name: "rejectForm" });
  },
  created() {
    this.isMaternityLeave = this.data.reason_type === MATERNITY_LEAVE_TYPE;
    this.isOnsiteRequest = this.data.reason_type === WORKING_TIME_ONSIDE_REQUEST;
    this.requestDetailSpan = this.isOnsiteRequest ? 12 : 24;
  },
  watch: {
    historyData() {
      if (this.historyData?.length > 0) {
        this.onHistoryActive(this.historyData[0]);
      }
    },
  },
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      employeeList: (state) => state.application.employeeList,
      userInfo: (state) => state.user.userInfo,
      timeServer: (state) => state.application.timeServer,
      historyData: (state) => state.request.historyData,
    }),
  },
  methods: {
    checkShowWithLastTimesheet,
    formatDate,
    getData,
    getInfoStaff,
    toFixedNumber,
    checkShowDelegate(record) {
      const { lastTimesheet, roles, visibleDelegate, timeServer } = this;
      return (
        checkShowWithLastTimesheet(
          record.start_date,
          lastTimesheet?.last_timesheet_period_end_date,
          TIME_PM,
          DATE_FORMAT_SHORT,
          timeServer
        ) &&
        record.status_type === "PENDING" &&
        (roles.includes(Role.GROUP_LEAD) || roles.includes(Role.DULEAD)) &&
        !visibleDelegate
      );
    },
    handleDelegate() {
      this.visibleDelegate = !this.visibleDelegate;
    },
    handCancelDelegate() {
      this.visibleDelegate = false;
    },
    handleCancel() {
      this.visibleModalReject = false;
      this.rejectForm.resetFields();
    },
    handleOk() {
      this.rejectForm.validateFields((err, values) => {
        if (err) return;
        const { reason } = values;
        if (reason && reason.trim() !== "") {
          this.statusPayload.reason = reason;
          this.updateStatus();
        } else {
          this.rejectWithdrawForm.setFields({
            reason: { value: "", errors: [{ message: "Reason is required" }] },
          });
        }
      });
    },
    handleSaveDelegate() {
      this.form.validateFields(async (error, value) => {
        if (error) return;
        try {
          const { approver } = value;
          const res = await this.$store.dispatch("request/updateRequestDelegate", {
            id: this.data.id,
            approver,
          });
          const { code, message } = res;
          if (code == 200) {
            this.$message.success(message);
            this.getRequestList();
            this.hideDrawer();
          } else {
            this.$message.error(message);
          }
        } catch (error) {
          this.$message.error(error.response.data.message);
        }
      });
    },
    onSearchDelegator(value) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then(() => {
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, 1000);
      }
    },
    onClickWithDraw(record, status) {
      if (this.handleClickWithdraw) {
        this.handleClickWithdraw(record, status);
      }
    },
    onClickReject(record, status) {
      if (this.handleClickReject) {
        this.handleClickReject(record, status);
      }
    },
    onClickApprove(record, status) {
      if (this.handleClickApprove) {
        this.handleClickApprove(record, status);
      }
    },
    handleOkConfirm() {
      this.updateStatus();
    },
    handleCancelConfirm() {
      this.visibleModalConfirm = false;
    },
    updateStatus() {
      this.isLoading = true;
      this.$store
        .dispatch("request/updateStatusRequest", this.statusPayload)
        .then((res) => {
          if (res) {
            if (parseInt(res.code) === 200) {
              this.$message.success(res.message);
              this.hideDrawer();
              this.visibleModalConfirm = false;
              this.visibleModalReject = false;
              this.getRequestList();
            } else {
              this.$message.error(res.message);
            }
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleDownload() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/${this.request_type}/${this.data.id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    onHistoryActive(history) {
      const { id } = history;
      this.activeId = id;
      // this.data = new_record ?? null;
    },
  },
};
